import { combineReducers } from "redux";
import competitorsReducer from "./features/reducers/competitorsReducer";
import businessUnitAccDetailsReducer from "./features/reducers/businessUnitAccDetailsReducer";
import questionsPrompterDataReducer from "./features/reducers/questionsPrompterDataReducer";
import documentReducer from "./features/reducers/documentReducer";
import techLandscapeReducer from "./features/reducers/techLandscapeReducer";
import keyTechnologiesReducer from "./features/reducers/keyTechnologiesReducer";
import accBuNudgeReducer from "./features/reducers/accountBuNudgesReducer";
import growthOpportunitiesByAccountAndClientReducer from "./features/reducers/growthOpportunitiesByAccountAndClientReducer";
import accountContactsReducer from "./features/reducers/accountContactsReducer";
import eventsReducer from "./features/reducers/eventsReducer";
import newProjectsReducer from "./features/reducers/newProjectsReducer";
import companyCompareReducers from "./features/reducers/companyCompareReducers";
import companyBuFinancialsReducer from "./features/reducers/companyBuFinancialsReducer";
import clientNudgeReducer from "./features/reducers/clientNudgeReducer";
import fetchRevenueAnalysisReducer from "./features/reducers/fetchRevenueAnalysisReducer";
import fetchGeoWiseRevenueAnalysisReducer from "./features/reducers/fetchGeoWiseRevenueAnalysisReducer";
import accountsReducer from "./features/reducers/accountsReducer";
import companyFinancialsReducer from "./features/reducers/companyFinancialsReducer";
import segmentsReducer from "./features/reducers/segmentsReducer";
import keyConversationReducer from "./features/reducers/keyConversationReducer";
import closureReducer from "./features/reducers/closureAgentReducer";
import { championReducer } from "./features/reducers/championAgentReducer";
import deliveryExcellenceReducer from "./features/reducers/deliveryExcellenceReducer";
import renewalReducer from "./features/reducers/renewalAgentReducer";
import { getLiveAccountsReducer } from "./features/reducers/fetchLiveAccountsReducer";
import dynamicTabsReducer from "./features/reducers/dynamicTabsReducer";
import { globalReducer } from "./features/reducers/commonReducer";
import demoRequestReducer from "./features/reducers/demoRequestReducer";
import battleCardReducer from "./features/reducers/opportunities/battleCardReducer";
import newsReducer from "./features/reducers/opportunities/newsReducer";
import businessCaseReducer from "./features/reducers/opportunities/businessCaseReducer";
import contactCardReducer from "./features/reducers/opportunities/contactCardReducer";
import valueSellingCardReducer from "./features/reducers/opportunities/valueSellingCardReducer";
import nextStepCardReducer from "./features/reducers/opportunities/nextStepCardReducer";
import opportunitiesReducer from "./features/reducers/opportunities/opportunitiesReducer";
import convertToWinReducer from "./features/reducers/opportunities/convertToWinReducer";
import winOpportunitiesReducer from "./features/reducers/opportunities/winOpportunitiesReducer";
import createDealReducer from "./features/reducers/opportunities/increaseDealSizeReducers/createDealReducer";
import listDealsReducer from "./features/reducers/opportunities/increaseDealSizeReducers/listDealReducer";
import spotContactsReducer from "./features/reducers/targetedReachoutReducers/spotContactsReducers";
import spotContactOppMapReducer from "./features/reducers/targetedReachoutReducers/spotContactOppMapReducer";
import increaseDealSizeCardReducer from "./features/reducers/opportunities/increaseDealSizeCardReducer";
import {
  globalMemDataReducer,
  listGlobalMemDataReducer,
  listGlobalMemDocDataReducer,
} from "./features/reducers/memory/globalMemoryReducer";
import nudgesNewReducer from "./features/reducers/nudgesNewReducer";
import meetingPrepsReducer from "./features/reducers/meetingPrepReducers/meetingPrepsReducers";
import battleCardMpReducer from "./features/reducers/meetingPrepReducers/battleCardReducer";
import nextStepsMpCardReducer from "./features/reducers/meetingPrepReducers/nextStepsMpCardReducer";
import meetingPrepPromptersCardReducer from "./features/reducers/meetingPrepReducers/promptersCardReducer";
import spotContactBCReducer from "./features/reducers/targetedReachoutReducers/spotContactBattleCardReducer";
import pitchWoReducer from "./features/reducers/opportunities/pitchCardWOReducer";
import operationsSupplyChainReducer from "./features/reducers/operationsSupplyChainReducer";
import corporateAndOrgStructureReducer from "./features/reducers/corporateAndOrgStructureReducer";
import competitorProfileReducer from "./features/reducers/competitorProfileReducer";
import competitorProfileV1Reducer from "./features/reducers/competitorProfileV1Reducer";
import competitorProfileV3Reducer from "./features/reducers/competitorProfileV3Reducer";
import competitorListReducer from "./features/reducers/competitorListReducer";
import selfFinancialsGiqReducer from "./features/reducers/selfFinancialsGiqReducer";
import competitorProfileV4Reducer from "./features/reducers/competitorProfileV4Reducer";
import createCompetitorReducer from "./features/reducers/createCompetitorReducer";
import baselineMarketDetailsReducer from "./features/reducers/baselineMarketDetailsReducer";
import competitorStatusReducer from "./features/reducers/competitorStatusReducer";
import suggestedCompetitorReducer from "./features/reducers/suggestedCompetitorReducer";
import fetchSuggestedCompetitorsReducer from "./features/reducers/fetchSuggestedCompetitorReducer";
import fetchClientIndustriesCompetitorsReducer from "./features/reducers/fetchClientIndustriesCompetitorsReducer";
import forgotPasswordReducer from "./features/reducers/forgotPasswordReducer";
import fetchExistingSubdimensionsReducer from "./features/reducers/fetchExistingSubdimensionsReducer";
import newUpdatesReducer from "./features/reducers/newUpdatesReducer";
import updateCompetitorProfileReducer from "./features/reducers/updateCompetitorProfileReducer";
import competitorAiTableReducer from "./features/reducers/competitorAiTableReducer";
import fetchBenchmarkingReducer from "./features/reducers/fetchBenchmarkingReducer";
import createBenchmarkReducer from "./features/reducers/createBenchmarkReducer";
import benchmarkGenerationStatusReducer from "./features/reducers/benchmarkGenerationStatusReducer";

const rootReducer = combineReducers({
  competitorsReducer,
  businessUnitAccDetailsReducer,
  questionsPrompterDataReducer,
  documentReducer,
  techLandscapeReducer,
  keyTechnologiesReducer,
  accBuNudgeReducer,
  growthOpportunitiesByAccountAndClientReducer,
  accountContactsReducer,
  eventsReducer,
  newProjectsReducer,
  companyCompareReducers,
  companyBuFinancialsReducer,
  clientNudgeReducer,
  fetchRevenueAnalysisReducer,
  fetchGeoWiseRevenueAnalysisReducer,
  accountsReducer,
  companyFinancialsReducer,
  segmentsReducer,
  keyConversationReducer,
  closureReducer,
  championReducer,
  deliveryExcellenceReducer,
  renewalReducer,
  getLiveAccountsReducer,
  dynamicTabsReducer,
  globalReducer,
  demoRequestReducer,
  opportunitiesReducer,
  battleCardReducer,
  newsReducer,
  businessCaseReducer,
  contactCardReducer,
  valueSellingCardReducer,
  nextStepCardReducer,
  convertToWinReducer,
  winOpportunitiesReducer,
  createDealReducer,
  listDealsReducer,
  spotContactsReducer,
  spotContactOppMapReducer,
  increaseDealSizeCardReducer,
  globalMemDataReducer,
  listGlobalMemDataReducer,
  listGlobalMemDocDataReducer,
  nudgesNewReducer,
  meetingPrepsReducer,
  battleCardMpReducer,
  nextStepsMpCardReducer,
  spotContactBCReducer,
  pitchWoReducer,
  meetingPrepPromptersCardReducer,
  operationsSupplyChainReducer,
  corporateAndOrgStructureReducer,
  competitorProfileReducer,
  competitorProfileV1Reducer,
  competitorProfileV3Reducer,
  competitorListReducer,
  selfFinancialsGiqReducer,
  competitorProfileV4Reducer,
  createCompetitorReducer,
  baselineMarketDetailsReducer,
  competitorStatusReducer,
  suggestedCompetitorReducer,
  fetchSuggestedCompetitorsReducer,
  fetchClientIndustriesCompetitorsReducer,
  forgotPasswordReducer,
  fetchExistingSubdimensionsReducer,
  newUpdatesReducer,
  updateCompetitorProfileReducer,
  competitorAiTableReducer,
  fetchBenchmarkingReducer,
  createBenchmarkReducer,
  benchmarkGenerationStatusReducer,
});

export default rootReducer;
